import {
  PAYMENT_REQUEST, GET_PAYMENT_DASHBOARD_SUCCESS, GET_PAYMENTS_SUCCESS,
  ADD_PAYMENT_SUCCESS, UPDATE_PAYMENT_SUCCESS, DELETE_PAYMENT_SUCCESS,
} from '../constant';

const initial = {
  dashboard: null,
  payments: [],
  loading: false,
};

export const paymentReducer = (state = initial, action) => {
  switch (action.type) {
    case PAYMENT_REQUEST:
      return { ...state, loading: true };
    case GET_PAYMENT_DASHBOARD_SUCCESS:
      return { ...state, loading: false, dashboard: action.payload };
    case GET_PAYMENTS_SUCCESS:
      return { ...state, loading: false, payments: action.payload };
    case ADD_PAYMENT_SUCCESS:
      return { ...state, payments: [action.payload, ...state.payments] };
    case UPDATE_PAYMENT_SUCCESS:
      return {
        ...state,
        payments: state.payments.map(p => p._id === action.payload._id ? action.payload : p),
      };
    case DELETE_PAYMENT_SUCCESS:
      return { ...state, payments: state.payments.filter(p => p._id !== action.payload) };
    default:
      return state;
  }
};
